import styled from "styled-components";

export const Wrapper = styled.section`
    margin:20px;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
`;

export const HeaderTitle = styled.h1`
    margin:0px 0px 40px 0px;
    font-size: 36px;
    font-style: normal;
    font-weight: 600;
    line-height: 43px;
    letter-spacing: 0px;
    align-self:flex-start;
`;

export const StyledImage = styled.img`
    max-width:100%;
    margin:0px auto;
`;
